export const bibleConstants = {
	BibleGetByFilterRequest: "FETCH_BIBLE_GETBYFILTER_STARTED",
	BibleGetByFilterSuccess: "FETCH_BIBLE_GETBYFILTER_COMPLETED",
	BibleGetByFilterFailure: "FETCH_BIBLE_GETBYFILTER_FAILED",

	BibleGetDetailRequest: "FETCH_BIBLE_DETAIL_STARTED",
	BibleGetDetailSuccess: "FETCH_BIBLE_DETAIL_COMPLETED",
	BibleGetDetailFailure: "FETCH_BIBLE_DETAIL_FAILED",

	BibleSaveRequest: "BIBLE_SAVE_STARTED",
	BibleSaveSuccess: "BIBLE_SAVE_COMPLETED",
	BibleSaveFailure: "BIBLE_SAVE_FAILED",

	BibleDeleteRequest: "BIBLE_DELETE_STARTED",
	BibleDeleteSuccess: "BIBLE_DELETE_COMPLETED",
	BibleDeleteFailure: "BIBLE_DELETE_FAILED",

	BibleGetAllRequest: "FETCH_BIBLE_GETALL_STARTED",
	BibleGetAllSuccess: "FETCH_BIBLE_GETALL_COMPLETED",
	BibleGetAllFailure: "FETCH_BIBLE_GETALL_FAILED",

	BibleTranslationSearchRequest: "BIBLE_TRANSLATION_SEARCH_STARTED",
	BibleTranslationSearchSuccess: "BIBLE_TRANSLATION_SEARCH_COMPLETED",
	BibleTranslationSearchFailure: "BIBLE_TRANSLATION_SEARCH_FAILED"
}